import {RaEvent, RaEventType} from "./RaEvent";

export enum EXIT_STATUS {
    ok,
    error
}

export class ReEnterEvent extends RaEvent {
    static TYPE:RaEventType = "reenter_event";
    constructor() {
        super(ReEnterEvent.TYPE);
    }
}

export class ExitEvent extends RaEvent {

    static TYPE:RaEventType = "exit_event";

    constructor(private _status:EXIT_STATUS) {
        super(ExitEvent.TYPE);
    }

    public get status():EXIT_STATUS {
        return this._status;
    }
}